import type { Project } from '@/modules/Projects/useProjects'
import { defineStore } from 'pinia'
import { ref, type Ref } from 'vue'

export const useAgentStore = defineStore('agents', () => {
  const agents: Ref<Map<string, Project>> = ref(new Map())

  return { agents }
})
